import HospitalPreference from "./hospitalPreference"
import { Consumer, Provider, HospitalPreferenceContext } from "./hospitalPreference.context"

export { Consumer, Provider, HospitalPreferenceContext }
export { config } from "./_config"

export default HospitalPreference
